import img_title from '../images/joinus/title.png';
import img1 from '../images/joinus/1.png';
import img2 from '../images/joinus/2.png';
import img3 from '../images/joinus/3.png';
import img4 from '../images/joinus/4.png';
import img5 from '../images/joinus/5.png';

import imgh1 from '../images/joinus/h1.png';
import imgh2 from '../images/joinus/h2.png';
import imgh3 from '../images/joinus/h3.png';
import imgh4 from '../images/joinus/h4.png';
import imgh5 from '../images/joinus/h5.png';
import imgh6 from '../images/joinus/h6.png';
const dataJoinUs =
    {
        id: 1,  
    title: '合作优势',
    titleimg: img_title,
    pageTitle: "专业 · 分享 · 品质 · 责任",
    pageSubTitle: "合作模式 —— 区域服务商",
    pageDetail: "德联入驻服务商是指经德联车护特许授权，在授权区域内至少自营一家德联汽车服务门店（旗舰店或社区标准店规模），并在所在区域内为德联车护发展一定数量终端经销商，实施德联产品、服务、品牌的推广，为所在区域内德联终端授权经销门店提供产品分销、配送、售后、培训及其他营运支持的合作机构。",
        content: [
            {
                id :11,
                title: "德联的信誉保障",
                subtitle: "国内汽车精细化工品制造产业的上市企业，在广东省制造业民营企业中排名第81位。",
                img: img1,
            },
            {
                id :12,
                title: "配套的经营服务",
                subtitle: "以大数据为参考，帮助服务商解决资金周转问题。",
                img: img2,
            },
            {
                id :13,
                title: "便捷的信息系统",
                subtitle: "深度挖掘客户的需求，基于云端，系统化地采购和订单管理。",
                img: img3,
            },
            {
                id :14,
                title: "专业技术和技能培训",
                subtitle: "在传统燃油车领域，提供专业化的管理和技术培训；在新能源领域，拥有数个培训基地及学校。",
                img: img4,
            },
            {
                id :15,
                title: "最终用户营销服务",
                subtitle: "丰富的互联网手段对最终用户营销帮助 导流，增加终端客流；根据终端服务能力分流管理。",
                img: img5,
            }
    ],
    title1: '合作条件',
    content1: [
        {
            id :21,
            subtitle: "中国境内合法注册的独立法人企业或个体工商户，经营状况良好",
            img: imgh1,
        },
        {
            id :22,
            subtitle: "至少自营一家汽车服务终端门店",
            img: imgh2,
        },
        {
            id :23,
            subtitle: "认同德联车护的商业模式、发展理念和品牌价值观",
            img: imgh3,
        },
        {
            id :24,
            subtitle: "具备为用户提供汽车基本保养服务的设备和能力",
            img: imgh4,
        },
        {
            id :25,
            subtitle: "自营门店部分采用德联的营销物料、软件工具、服务标准",
            img: imgh5,
        },
        {
            id :26,
            subtitle: "承诺为德联车护实现一定的业绩目标（包括德联产品销售及服务商拓展）",
            img: imgh6,
        }
    ]
    }

export default dataJoinUs;